import { getAuthSignIn } from "./api.request";

const AUTH_PATH = 'apis/auth/sign-in';

export const authSignIn = async (body) => getAuthSignIn(`${AUTH_PATH}`, body);